var _defs, _polygon, _polygon2, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _ellipse2, _polygon3, _polygon4, _path11, _rect, _path12, _rect2, _rect3, _path13, _path14, _polygon5, _polygon6, _g3, _path15, _g4, _path16, _polygon7, _g5, _polygon8, _path17, _path18, _polygon9, _ellipse3, _path19, _polygon10, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse4, _polygon11, _polygon12, _rect4, _rect5, _polygon13, _path26, _path27, _path28, _polygon14, _rect6, _rect7, _g6, _rect8, _path29, _path30, _path31, _rect9, _rect10, _path32, _circle, _circle2, _path33, _path34, _ellipse5, _ellipse6, _circle3, _path35, _path36, _circle4, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1a6977f7-86c5-489f-b4ea-e3d25c51345c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 682,
    height: 729.04,
    viewBox: "0 0 682 729.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f0fb461d-1e13-41a3-9bae-441dc4ab432e",
    x1: 133.13,
    y1: 136.42,
    x2: 133.13,
    y2: 112.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9338db18-7559-4922-b07d-af0763e35872",
    x1: 489.15,
    y1: 260.63,
    x2: 489.15,
    y2: 85.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "237fef21-1688-4881-b2bf-1fb5e7fb841a",
    x1: 513.83,
    y1: 188.41,
    x2: 513.83,
    y2: 161.09,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0806d1c2-0f4f-4b8f-84fd-fc6edc7c1131",
    x1: 538.04,
    y1: 200.61,
    x2: 538.04,
    y2: 160.52,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1a3a1de-9246-4c88-858b-24cfccd1a194",
    x1: 521.42,
    y1: 391.07,
    x2: 521.42,
    y2: 279.81,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c6ba120c-8293-4062-90c8-1be9135906c1",
    x1: 567.94,
    y1: 627.32,
    x2: 604.26,
    y2: 627.32,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e4220eb-06fe-475c-b983-612df507c483",
    x1: 826.94,
    y1: 703.92,
    x2: 863.26,
    y2: 703.92,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3c708c16-9b8c-4a6b-bd21-71ed55c4fac7",
    x1: 826.94,
    y1: 684.58,
    x2: 863.26,
    y2: 684.58,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "914b7834-b170-4122-94aa-7fb871bfc45a",
    x1: 840.76,
    y1: 659.51,
    x2: 849.44,
    y2: 659.51,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e880cd7d-1fd8-4b3a-94c2-2cb4fc2bb4c9",
    x1: 567.94,
    y1: 675.48,
    x2: 580.97,
    y2: 675.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6d9eaa8-5592-4443-bad9-2a3577dac70a",
    x1: 591.23,
    y1: 675.48,
    x2: 604.26,
    y2: 675.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "95c69d72-14b0-480a-a21f-2a6d2460d317",
    x1: 840.76,
    y1: 656.16,
    x2: 849.44,
    y2: 656.16,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "351ee021-cb35-4453-b11f-492b50bee9b0",
    x1: 567.15,
    y1: 551.13,
    x2: 605.05,
    y2: 551.13,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5621d9a8-91aa-4808-a611-4b960d09f38a",
    x1: 567.94,
    y1: 555.48,
    x2: 604.26,
    y2: 555.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7e4198ff-734f-43ff-9955-e14b5b76a5ab",
    x1: 831.28,
    y1: 628.45,
    x2: 863.01,
    y2: 628.45,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6526c489-0973-4e11-a508-f591bbdde1c0",
    x1: 831.28,
    y1: 628.05,
    x2: 863.01,
    y2: 628.05,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "294d64f1-65de-4cb7-bc36-babf1fd7cdb8",
    x1: 602.48,
    y1: 555.48,
    x2: 605.64,
    y2: 555.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9d28fa30-49df-43d8-bb66-05ac5ec48c44",
    x1: 566.56,
    y1: 555.48,
    x2: 569.72,
    y2: 555.48,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "12340055-3359-4d15-9968-477745c3ee74",
    x1: 630.31,
    y1: 532.19,
    x2: 639,
    y2: 532.19,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8dbeea2f-d4f1-4427-aab1-3bd1f0b524da",
    x1: 827.34,
    y1: 651.42,
    x2: 863.03,
    y2: 651.42,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4cafde90-344a-4afb-8ffe-f39d11d6fd38",
    x1: 854.75,
    y1: 646.88,
    x2: 895.24,
    y2: 646.88,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2169112d-c0fa-43f5-b379-e37054a62c36",
    x1: 533.2,
    y1: 532.19,
    x2: 541.89,
    y2: 532.19,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1c260ce5-6e82-4073-bcff-11545f734fbd",
    x1: 794.97,
    y1: 646.88,
    x2: 835.45,
    y2: 646.88,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a250eb33-caad-4b62-b507-377e200fabd4",
    x1: 827.73,
    y1: 805.18,
    x2: 839.18,
    y2: 805.18,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fafa91f3-3852-4c4c-bdd1-6ec8b3cc9d69",
    x1: 851.02,
    y1: 805.18,
    x2: 862.47,
    y2: 805.18,
    xlinkHref: "#f0fb461d-1e13-41a3-9bae-441dc4ab432e"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bitcoin2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "128.15 116.08 139.19 111.82 142.09 118.13 143.43 133.21 140.96 135 128.15 116.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.79 145.78 169.18 153.07 182.43 172.61 185.52 170.36 187.44 154.85 181.79 145.78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.24,140.23c-2.54,3.84-4.91,8-5.64,10.92l2-1.38C463.35,147.6,465,144,467.24,140.23Z",
    transform: "translate(-259 -85.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.61,192.49,480,163.26c-31,19.67-76.36,37.62-76.36,37.62l-2.19,3.47s45.41-17.95,76.36-37.62l-1.3,27.53Z",
    transform: "translate(-259 -85.48)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.46 136.42 141 134.57 139.63 119.04 136.64 112.55 125.27 116.94 138.46 136.42",
    fill: "url(#f0fb461d-1e13-41a3-9bae-441dc4ab432e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.58,87.36c-6.91-3.32-12.08-1.76-15.7,1a22.73,22.73,0,0,0-7.31,9.42l-1,2.65h0l-4.68,3.4-1.52-3.25s-16.57-29.44-65.45,28.05l-.22-.18s-4.16,5.09-7.95,10.8l-.54.82-.24.37-.34.53-.25.4L465,142l-.33.54-.35.59-.25.43-.26.45-.25.45-.26.48-.38.72-.21.4-.23.47-.17.36-.22.47-.14.31q-.18.42-.34.82l-.12.31-.16.44-.1.3q-.11.34-.2.67c0,.12-.07.23-.09.34h0a6.39,6.39,0,0,0-.22,2.16L395.64,198l3.34,7.26s46.77-18.48,78.65-38.75l-1.34,28.35h0l-.08,1.75S447.09,220.72,439.51,233l-13,7.51,13.65,20.12,3.18-2.31,2-16,53.43-42.71s10.13-18.51,10.31-34l2.19,8.45s4.66,13.09,7.95,13.61,3.3-10.15,1-13.32S519,150,519,150l.6-4.31,8.36-6.08.31-.29.44,2.66,1.68.15v.12h0l.08.77h0l1.08,20.19,5.92,22.84s4.66,13.09,7.95,13.61,3.3-10.15,1-13.32S545.21,162,545.21,162l2.44-17.63h0l0-.34.05-.39,4.81.42s5-17.19-3.37-24.68l-1.52-3.25,3.12-2.26h0l.63-.45a14.15,14.15,0,0,0,19.79,0,9.87,9.87,0,0,0,6.6-1.76l1.21-.87a16,16,0,0,0,3.49-3C583.31,106.21,581.28,92.49,570.58,87.36Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#9338db18-7559-4922-b07d-af0763e35872)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475,129.75s-14.23,17.4-13.56,23.5L398.2,197.3l3.24,7.05s45.41-17.95,76.36-37.62L476.42,196s-28.27,23.37-35.62,35.3l5.65,9.07,51.88-41.47s15.39-28.12,8-43.46Z",
    transform: "translate(-259 -85.48)",
    fill: "#535461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M930.79,556C885.24,738.68,700.2,849.87,517.48,804.31S223.64,573.7,269.22,391,499.79,97.1,682.45,142.65,976.34,373.27,930.79,556Z",
    transform: "translate(-259 -85.48)",
    fill: "#f7931a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M750.36,424.9c6.79-45.38-27.76-69.77-75-86l15.33-61.47-37.42-9.33L638.34,327.9c-9.84-2.45-19.94-4.76-30-7.06l15-60.25L586,251.28l-15.34,61.45c-8.14-1.85-16.14-3.69-23.89-5.62l0-.19L495.2,294l-10,40s27.76,6.36,27.18,6.76c15.15,3.78,17.89,13.81,17.44,21.76l-17.46,70a31,31,0,0,1,3.89,1.25c-1.25-.31-2.58-.65-4-1l-24.47,98.1c-1.85,4.6-6.55,11.51-17.15,8.89.37.54-27.2-6.79-27.2-6.79L425,575.85,473.64,588c9.06,2.27,17.94,4.65,26.68,6.88L484.84,657l37.38,9.33,15.34-61.51c10.21,2.77,20.12,5.33,29.82,7.74l-15.28,61.23,37.42,9.33L605,621.09c63.81,12.07,111.79,7.2,132-50.51,16.27-46.47-.81-73.27-34.38-90.75C727,474.2,745.45,458.12,750.36,424.9ZM664.87,544.78c-11.56,46.47-89.8,21.35-115.16,15l20.55-82.37C595.62,483.79,677,496.32,664.87,544.78Zm11.57-120.56c-10.55,42.27-75.67,20.79-96.79,15.53L598.28,365C619.41,370.31,687.43,380.14,676.44,424.22Z",
    transform: "translate(-259 -85.48)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M528.49,132.71l1.64,30.8,5.74,22.17s4.52,12.71,7.72,13.21,3.21-9.86,1-12.94-1.15-23.63-1.15-23.63L547,136.17Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M526.58,137.87l.83,5,23.14,2s4.84-16.69-3.28-24Z",
    transform: "translate(-259 -85.48)",
    fill: "#f55f44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M547.27,120.94l-8.55-18.25S522.57,74,474.87,130.28l31.46,25.12,20.36-14.8Z",
    transform: "translate(-259 -85.48)",
    fill: "#f55f44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M540.85,95.71h12.94a0,0,0,0,1,0,0v20.53a5.4,5.4,0,0,1-5.4,5.4h-2.13a5.4,5.4,0,0,1-5.4-5.4V95.71A0,0,0,0,1,540.85,95.71Z",
    transform: "translate(54.45 -483.43) rotate(53.99)",
    fill: "#fda57d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M545.18,102.24a13.53,13.53,0,0,0,3.64,13.35l7.85-5.71-7.61-10.47Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.03,
    cy: 105.34,
    rx: 13.73,
    ry: 13.7,
    transform: "translate(-214.11 263.31) rotate(-36.01)",
    fill: "#fda57d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M552.68,97.25l-7.93,5.3,1-2.58s6.52-17,21.72-9.67c10.39,5,12.36,18.3,11.57,19.82a18.46,18.46,0,0,1-4,3.28,9.55,9.55,0,0,1-12.81-1.62c-2.66-3.17-7.3-9.73-6.45-13.49h0c-.78-1.42-1.8-2-3.11-1Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M553.3,96.8l-7.93,5.3,1-2.58s6.52-17,21.72-9.67c10.39,5,12.36,18.3,11.57,19.82a18.46,18.46,0,0,1-4,3.28,9.55,9.55,0,0,1-12.81-1.62c-2.66-3.17-7.3-9.73-6.45-13.49h0c-.78-1.42-1.8-2-3.11-1Z",
    transform: "translate(-259 -85.48)",
    fill: "#5a2f32"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.28,
    cy: 97.5,
    rx: 3.05,
    ry: 1.52,
    transform: "matrix(0.81, -0.59, 0.59, 0.81, -210.41, 259.02)",
    fill: "#fda57d"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.03 54.71 268.66 51.6 268.7 56.51 267.91 54.62 265.03 54.71",
    opacity: 0.05
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.01 57.67 270.09 58.43 286.78 59.73 286.88 59.02 270.01 57.67",
    opacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M503.07,121.08l1.64,30.8L510.45,174s4.52,12.71,7.72,13.21,3.21-9.86,1-12.94S518,150.69,518,150.69l3.62-26.15Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 378.48,
    y: 270.77,
    width: 1.74,
    height: 1.74,
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M377.35,273.39h4.3a2.35,2.35,0,0,1,2.35,2.35v14.49a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0V275.74A2.35,2.35,0,0,1,377.35,273.39Z",
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 376.74,
    y: 272.23,
    width: 5.23,
    height: 1.16,
    fill: "#f7931a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 280.06,
    width: 9,
    height: 3.48,
    fill: "#f7931a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M639.23,356.54v.87c-.32,0-.58-.2-.58-.44S638.91,356.54,639.23,356.54Z",
    transform: "translate(-259 -85.48)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.91,106.1s-3.82,10.31-2.2,13.83",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.15 35.07 244.14 36.98 262.47 40.06 262.69 38.53 244.15 35.07",
    opacity: 0.05
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.29 19.36 244.07 35.6 262.61 39.06 267.51 18.56 248.29 19.36",
    fill: "#f55f44"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.66,161.09l3.65,13.82s4.71,13,8,13.49,3.34-10.07,1-13.21c-1.23-1.65-1.49-8.23-1.47-14.1Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#237fef21-1688-4881-b2bf-1fb5e7fb841a)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M506.95,161.09l3.51,13.53s4.52,12.71,7.72,13.21,3.21-9.86,1-12.94c-1.18-1.62-1.43-8.06-1.41-13.8Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.07,160.52h-14.6l.2,3.66L535.75,187s4.79,13.08,8.17,13.6,3.39-10.15,1-13.31S543.73,163,543.73,163Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#0806d1c2-0f4f-4b8f-84fd-fc6edc7c1131)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M543.74,160.52h-13.8l.19,3.56,5.74,22.17s4.52,12.71,7.72,13.21,3.21-9.86,1-12.94-1.15-23.63-1.15-23.63Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "380 271 405 266 406 278 380 272 380 271",
    fill: "#535461",
    opacity: 0.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.28,360.18l.69.3h0l22,9.47L652,336.7s4.25-4.75-.81-8-8.24,5.16-8.24,5.16L621.41,357l-18.3-9.15.29-1.92-16.68-9.64a20.48,20.48,0,0,0-1.06-1.77l-.15-.54-.83-.73c-.16-.17-.32-.33-.48-.47l2.76-3a14.85,14.85,0,0,0,19.58-11.7,10.45,10.45,0,0,0,3.91,0,10.78,10.78,0,0,0,7.7-6.33.79.79,0,0,1-.57.41,10.11,10.11,0,0,0,.57-1.16c-.57,1.38-5.9-.52-6.7-1-2.44-1.3-3.7-3.22-5-5.58-2.49-4.66-7.09-6.38-12.27-6.79a25.52,25.52,0,0,0-11.69,1.47,14.4,14.4,0,0,0-8.23,8.11,10.71,10.71,0,0,0-.6,3.95,9.66,9.66,0,0,0,3.14,7.71,6.75,6.75,0,0,0,.57.44c.11.43.23.85.38,1.27l-.73.79,0,0-4.74,5.14-.24-.07-49.93,7.47v.1c-1.66-1.1-9.18-4.92-27.95.27-7.09,2-18.9,1.75-31.58.58C453.72,323.84,448,289.52,448,289.52l-2.24-9.71-29.07,6.72s13.41,3,15.65,6.72c3.41,1.14,5.52,26.61,6.33,38.63-17.41-2.69-31.67-5.77-31.67-5.77l-10.43-3.73-7.45,26.14s8.2-9,15.65-9.71c0,0,37.26,17.92,64.84,14.19,10.74-1.45,21.12,3.09,29.81,4.48a169.82,169.82,0,0,0,23,2.24l.09,8.21s30.69-1.32,50.85-7.72c1.53,4.14,2.76,7.13,3.19,7.35l3.66-1.79,20.56,25.31L641,374.64s6-2.24,3-7.47-9.69.75-9.69.75l-29.81,10.45-12.58-17.44h0l-.49-.68,2.64-1.29s-.08-.39-.24-1.06l6.94,5.54Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#f1a3a1de-9246-4c88-858b-24cfccd1a194)"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.96 253.33 308.75 244.79 324 228.26 333.21 236.79 317.96 253.33",
    fill: "#fda57d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M582.27,314.46l-6.73,7.3a14.53,14.53,0,0,0,8.91,8.87l7-7.63Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M584.25,353.11,621.18,369l27.29-32.34s4.13-4.62-.79-7.78-8,5-8,5l-21,22.48L591.73,342.9Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.31 249.24 342.16 260.13 339.62 277.2 321.86 263.04 323.31 249.24",
    fill: "#6666ff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.92,
    cy: 230.72,
    rx: 14.5,
    ry: 14.53,
    fill: "#fda57d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M578,328.91l-7.25-2.18L522.15,334l.36,33s59.08-2.54,65.6-17.79L583.76,334Z",
    transform: "translate(-259 -85.48)",
    fill: "#6666ff"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.43 263.48 339.62 277.2 340.35 271.39 323.31 255.05 322.43 263.48",
    opacity: 0.05
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M522.51,334.35s-6.52-5.81-27.54,0-84.81-8-84.81-8L408,338.71s36.24,17.43,63.06,13.8c10.44-1.41,20.54,3,29,4.36A163.18,163.18,0,0,0,522.51,359Z",
    transform: "translate(-259 -85.48)",
    fill: "#4d8af0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M410.16,326.36,400,322.73l-7.25,25.42s8-8.72,15.22-9.44Z",
    transform: "translate(-259 -85.48)",
    fill: "#535461"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M434.8,294.41,450,290.78s7.25,43.58,18.12,47.21H441.33S439.15,295.86,434.8,294.41Z",
    transform: "translate(-259 -85.48)",
    fill: "#4d8af0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M450,290.78l-2.17-9.44-28.27,6.54s13,2.91,15.22,6.54Z",
    transform: "translate(-259 -85.48)",
    fill: "#535461"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M592.23,299.4a24.82,24.82,0,0,0-11.37,1.43,14,14,0,0,0-8,7.89c-1.3,3.64-.46,8.11,2.48,10.61a4.33,4.33,0,0,0,2.55,1.16c1.54.06,2.83-1.07,4-2.05a33.84,33.84,0,0,1,7.28-4.59c2.22-1,4.93-1.8,7-.53a14.53,14.53,0,0,1,2.53,2.4,10.29,10.29,0,0,0,16.76-3.36c-.56,1.35-5.74-.51-6.52-.92-2.38-1.26-3.6-3.13-4.82-5.42C601.74,301.47,597.26,299.8,592.23,299.4Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M592.23,298.68a24.82,24.82,0,0,0-11.37,1.43,14,14,0,0,0-8,7.89c-1.3,3.64-.46,8.11,2.48,10.61a4.33,4.33,0,0,0,2.55,1.16c1.54.06,2.83-1.07,4-2.05a33.84,33.84,0,0,1,7.28-4.59c2.22-1,4.93-1.8,7-.53a14.53,14.53,0,0,1,2.53,2.4,10.29,10.29,0,0,0,16.76-3.36c-.56,1.35-5.74-.51-6.52-.92-2.38-1.26-3.6-3.13-4.82-5.42C601.74,300.75,597.26,299.07,592.23,298.68Z",
    transform: "translate(-259 -85.48)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.21,
    cy: 314.74,
    rx: 2.18,
    ry: 1.09,
    transform: "translate(-115.15 725.99) rotate(-76.65)",
    fill: "#fda57d"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.62 279.45 320.11 280.05 331.01 274.76 330.53 274.1 319.62 279.45",
    opacity: 0.05
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "341.88 262 340.1 273.93 340.76 274.31 342.16 262.13 341.88 262",
    opacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.83,
    y: 231.44,
    width: 8.7,
    height: 58.83,
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 509.25,
    y: 152.08,
    width: 8.7,
    height: 58.83,
    transform: "translate(-174.46 -239.6) rotate(18.57)",
    fill: "#e0e0e0"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.63 237.98 278.73 237.98 278.73 95.92 281.59 96.07 281.63 237.98",
    fill: "#e0e0e0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M573.25,358.32l25.37,31.23,39.14-16s5.8-2.18,2.9-7.26-9.42.73-9.42.73l-29,10.17-17.64-24.45Z",
    transform: "translate(-259 -85.48)",
    fill: "#fda57d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M562.74,332.54s10.87,33.41,12.32,34.13l17-8.35s-4.83-22.53-10.21-26S563.47,329.63,562.74,332.54Z",
    transform: "translate(-259 -85.48)",
    fill: "#6666ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M565.84,341.91s-.57,12.78,3.06,15",
    transform: "translate(-259 -85.48)",
    opacity: 0.05
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "278.75 96.07 265.67 76.74 267.04 72.65 281.59 96.07 278.75 96.07",
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 600.51,
    y: 320.41,
    width: 2.27,
    height: 5.73,
    transform: "translate(20.47 -364.44) rotate(33.6)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 585.89,
    y: 316.49,
    width: 16.83,
    height: 1.14,
    transform: "translate(15.91 -361.48) rotate(33.62)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.94,
    y: 613.9,
    width: 36.32,
    height: 26.84,
    fill: "url(#c6ba120c-8293-4062-90c8-1be9135906c1)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.94,706.49s13.55,1.58,18.16,1.58,18.16-1.58,18.16-1.58v-6.71H826.94Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#9e4220eb-06fe-475c-b983-612df507c483)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M863.26,706.09s-13.55,1.58-18.16,1.58-18.16-1.58-18.16-1.58V679.64a18.16,18.16,0,0,1,18.16-18.16h0a18.16,18.16,0,0,1,18.16,18.16Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#3c708c16-9b8c-4a6b-bd21-71ed55c4fac7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.1,666.62h0a4.34,4.34,0,0,1-4.34-4.34v-9.87h8.68v9.87A4.34,4.34,0,0,1,845.1,666.62Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#914b7834-b170-4122-94aa-7fb871bfc45a)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.94,
    y: 631.27,
    width: 13.03,
    height: 88.43,
    fill: "url(#e880cd7d-1fd8-4b3a-94c2-2cb4fc2bb4c9)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.23,
    y: 631.27,
    width: 13.03,
    height: 88.43,
    fill: "url(#b6d9eaa8-5592-4443-bad9-2a3577dac70a)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840.76,659a18.17,18.17,0,0,0,8.68,0V652.8h-8.68Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#95c69d72-14b0-480a-a21f-2a6d2460d317)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 586.1,
    cy: 551.13,
    r: 18.95,
    fill: "url(#351ee021-cb35-4453-b11f-492b50bee9b0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.1,
    cy: 555.48,
    r: 18.16,
    fill: "url(#5621d9a8-91aa-4808-a611-4b960d09f38a)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.1,631.85a8.33,8.33,0,0,0,3.21,1,28.29,28.29,0,0,0,13.78-1.55,6.73,6.73,0,0,0,4.34,3.67,19.94,19.94,0,0,0,5.82.65,2.16,2.16,0,0,0,1.25-.24c.87-.59.45-1.94-.06-2.86l-2.53-4.59a13.6,13.6,0,0,0-2.68-3.76,11.1,11.1,0,0,0-5.28-2.27,29.77,29.77,0,0,0-13.55.45C833.69,623.6,827.62,627.93,834.1,631.85Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#7e4198ff-734f-43ff-9955-e14b5b76a5ab)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.1,631.46a8.33,8.33,0,0,0,3.21,1,28.29,28.29,0,0,0,13.78-1.55,6.73,6.73,0,0,0,4.34,3.67,19.94,19.94,0,0,0,5.82.65,2.16,2.16,0,0,0,1.25-.24c.87-.59.45-1.94-.06-2.86l-2.53-4.59a13.6,13.6,0,0,0-2.68-3.76,11.1,11.1,0,0,0-5.28-2.27,29.77,29.77,0,0,0-13.55.45C833.69,623.21,827.62,627.53,834.1,631.46Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#6526c489-0973-4e11-a508-f591bbdde1c0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 604.06,
    cy: 555.48,
    rx: 1.58,
    ry: 2.96,
    fill: "url(#294d64f1-65de-4cb7-bc36-babf1fd7cdb8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.14,
    cy: 555.48,
    rx: 1.58,
    ry: 2.96,
    fill: "url(#9d28fa30-49df-43d8-bb66-05ac5ec48c44)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.66,
    cy: 532.19,
    r: 4.34,
    fill: "url(#12340055-3359-4d15-9968-477745c3ee74)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(579.23 599.1)",
    fontSize: 11.84,
    fontFamily: "Lato-Light, Lato"
  }, "00"), /*#__PURE__*/React.createElement("path", {
    d: "M845.5,648.06s-10.26,3.55-18.16-4.34c0,0,.64,2.62,1.74,5.77a18.16,18.16,0,0,0,34-5.64C861.18,644.87,847.69,651.36,845.5,648.06Zm-.39,4.74c-2,0-3.55-1.5-3.55-2.37s1.59-.79,3.55-.79,3.55-.08,3.55.79S847.06,652.8,845.1,652.8Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#8dbeea2f-d4f1-4427-aab1-3bd1f0b524da)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.75,664.27s21.14-11.86,34.17-46.6l6.32,3.95s-10.46,44.27-36.71,54.48Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#4cafde90-344a-4afb-8ffe-f39d11d6fd38)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.55,
    cy: 532.19,
    r: 4.34,
    fill: "url(#2169112d-c0fa-43f5-b379-e37054a62c36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.45,664.27s-21.14-11.86-34.17-46.6L795,621.61s10.46,44.27,36.71,54.48Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#1c260ce5-6e82-4073-bcff-11545f734fbd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.18,808.34H827.73v-.59a5.72,5.72,0,0,1,5.72-5.72h0a5.72,5.72,0,0,1,5.72,5.72Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#a250eb33-caad-4b62-b507-377e200fabd4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.47,808.34H851v-.59a5.72,5.72,0,0,1,5.72-5.72h0a5.72,5.72,0,0,1,5.72,5.72Z",
    transform: "translate(-259 -85.48)",
    fill: "url(#fafa91f3-3852-4c4c-bdd1-6ec8b3cc9d69)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 568.47,
    y: 614.23,
    width: 35.27,
    height: 26.07,
    fill: "#4d8af0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M827.47,706.61s13.16,1.53,17.63,1.53,17.63-1.53,17.63-1.53V700.1H827.47Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M862.73,706.23s-13.16,1.53-17.63,1.53-17.63-1.53-17.63-1.53V680.55a17.63,17.63,0,0,1,17.63-17.63h0a17.63,17.63,0,0,1,17.63,17.63Z",
    transform: "translate(-259 -85.48)",
    fill: "#6666ff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M581.88,568.62h8.43a0,0,0,0,1,0,0v9.58a4.22,4.22,0,0,1-4.22,4.22h0a4.22,4.22,0,0,1-4.22-4.22v-9.58A0,0,0,0,1,581.88,568.62Z",
    fill: "#fdb797"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 568.47,
    y: 631.1,
    width: 12.65,
    height: 85.86,
    fill: "#4d8af0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 591.08,
    y: 631.1,
    width: 12.65,
    height: 85.86,
    fill: "#4d8af0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M840.89,660.49a17.64,17.64,0,0,0,8.43,0v-6h-8.43Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 586.1,
    cy: 553.29,
    r: 18.4,
    fill: "#814e4d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.1,
    cy: 557.5,
    r: 17.63,
    fill: "#fdb797"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M834.42,634.14a8.09,8.09,0,0,0,3.12.94,27.47,27.47,0,0,0,13.38-1.5,6.54,6.54,0,0,0,4.22,3.57,19.36,19.36,0,0,0,5.65.63,2.09,2.09,0,0,0,1.22-.23c.85-.57.44-1.88-.06-2.78l-2.46-4.45a13.21,13.21,0,0,0-2.6-3.65,10.78,10.78,0,0,0-5.13-2.2,28.91,28.91,0,0,0-13.16.44C834,626.13,828.12,630.33,834.42,634.14Z",
    transform: "translate(-259 -85.48)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M834.42,633.76a8.09,8.09,0,0,0,3.12.94,27.47,27.47,0,0,0,13.38-1.5,6.54,6.54,0,0,0,4.22,3.57,19.36,19.36,0,0,0,5.65.63,2.09,2.09,0,0,0,1.22-.23c.85-.57.44-1.88-.06-2.78l-2.46-4.45a13.21,13.21,0,0,0-2.6-3.65,10.78,10.78,0,0,0-5.13-2.2,28.91,28.91,0,0,0-13.16.44C834,625.75,828.12,629.95,834.42,633.76Z",
    transform: "translate(-259 -85.48)",
    fill: "#814e4d"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 603.54,
    cy: 557.5,
    rx: 1.53,
    ry: 2.87,
    fill: "#fdb797"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.66,
    cy: 557.5,
    rx: 1.53,
    ry: 2.87,
    fill: "#fdb797"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 633.25,
    cy: 534.89,
    r: 4.22,
    fill: "#fdb797"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M845.49,649.88s-10,3.45-17.63-4.22c0,0,.62,2.54,1.69,5.61a17.63,17.63,0,0,0,33-5.48C860.72,646.79,847.62,653.08,845.49,649.88Zm-.38,4.6c-1.91,0-3.45-1.45-3.45-2.3s1.54-.77,3.45-.77,3.45-.08,3.45.77S847,654.48,845.1,654.48Z",
    transform: "translate(-259 -85.48)",
    fill: "#814e4d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M854.47,665.62S875,654.1,887.65,620.37l6.13,3.83s-10.16,43-35.65,52.9Z",
    transform: "translate(-259 -85.48)",
    fill: "#6666ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.95,
    cy: 534.89,
    r: 4.22,
    fill: "#fdb797"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M835.73,665.62s-20.53-11.52-33.18-45.25l-6.13,3.83s10.16,43,35.65,52.9Z",
    transform: "translate(-259 -85.48)",
    fill: "#6666ff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M574.79,713.9h0a5.56,5.56,0,0,1,5.56,5.56V720a0,0,0,0,1,0,0H569.24a0,0,0,0,1,0,0v-.57A5.56,5.56,0,0,1,574.79,713.9Z",
    fill: "#333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M597.41,713.9h0a5.56,5.56,0,0,1,5.56,5.56V720a0,0,0,0,1,0,0H591.85a0,0,0,0,1,0,0v-.57A5.56,5.56,0,0,1,597.41,713.9Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.3f6f768653cc3025de77d714ead8bcbc.svg";
export { ForwardRef as ReactComponent };